module.exports = __webpack_public_path__ + "img/tkd_kick.540f75c1.svg";